import React from "react";

import PropTypes from "prop-types";

import { ReactComponent as IconAnchorRight24 } from "../../icons/icon/24/a-icon-anchorright-24.svg";
import LinkButton from "../button/linkButton";

const EyecatcherIcon = ({
  buttonLink = null,
  buttonText = null,
  children,
  icon = null,
  title = null,
}) => (
  <div className="eyecatcher eyecatcher--icon text-section__fullwidth">
    {icon && (
      <div className="eyecatcher__icon">
        {icon}
      </div>
    )}
    <div className="eyecatcher__title">
      {title && <h3>{title}</h3>}
      {buttonLink && buttonText && (
        <LinkButton href={buttonLink}>
          {buttonText}
          <IconAnchorRight24 />
        </LinkButton>
      )}
    </div>
    {children && (
      <div className="eyecatcher__elements-wrapper">
        <div className="eyecatcher__elements">
          {children}
        </div>
      </div>
    )}
  </div>
);

EyecatcherIcon.propTypes = {
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object,
  ]).isRequired,
  icon: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  title: PropTypes.string,
};

export default EyecatcherIcon;
